import { StyleSheet, Platform, Dimensions } from 'react-native';
import { fuentes, colores, fontSizes, spacing, layout } from './variablesCss';

const { width: viewportWidth } = Dimensions.get('window');
const isMobileWeb = Platform.OS === 'web' && viewportWidth < 768;

// Función helper para obtener el padding lateral según el tamaño de pantalla
export const getContentPadding = (width) => {
  return width < 768 ? layout.contentPaddingMobile : layout.contentPadding;
};

// Re-exportar layout para uso directo
export { layout };

// Estilos globales
export const globalStyles = StyleSheet.create({
  container: {
    flex: 1,
    padding: spacing.md,
    backgroundColor: colores.fondo,
  },
  // Contenedor principal con márgenes laterales consistentes
  alignedContainer: {
    width: '100%',
    paddingHorizontal: layout.contentPadding,
  },
  // Versión móvil del contenedor alineado
  alignedContainerMobile: {
    paddingHorizontal: layout.contentPaddingMobile,
  },
  // Estilos de texto con Montserrat
  text: {
    fontFamily: fuentes.regular,
    color: colores.textoPrincipal,
    fontSize: fontSizes.texto,
  },
  title: {
    fontFamily: fuentes.bold,
    fontSize: fontSizes.titulo,
    color: colores.textoPrincipal,
    marginBottom: spacing.sm,
  },
  subtitle: {
    fontFamily: fuentes.semiBold,
    fontSize: fontSizes.subtitulo,
    color: colores.textoPrincipal,
    marginBottom: spacing.sm,
  },
  // Texto con fuente medium
  textMedium: {
    fontFamily: fuentes.medium,
    color: colores.textoPrincipal,
    fontSize: fontSizes.texto,
  },
  button: {
    backgroundColor: colores.rojo,
    padding: spacing.sm,
    borderRadius: 6,
    alignItems: 'center',
  },
  buttonText: {
    fontFamily: fuentes.bold,
    color: colores.blanco,
    fontSize: fontSizes.texto,
  },
  // Estilos específicos para carruseles
  carousel: {
    width: '100%',
  },
  carouselScrollView: {
    // Estilos específicos para móvil web
    // Permitir scroll vertical (pan-y) mientras el carrusel maneja el horizontal
    ...(isMobileWeb ? {
      touchAction: 'pan-y',
      WebkitOverflowScrolling: 'touch',
      overscrollBehaviorX: 'contain',
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
    } : {}),
  },
  // Ocultar scrollbar en web
  '@media (min-width: 0px)': Platform.OS === 'web' ? {
    carouselScrollView: {
      '::-webkit-scrollbar': {
        display: 'none',
      },
    }
  } : {},
});